import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class HeroMap {
    constructor(query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.inner = this.el.querySelector('.hero-map__inner');
        this.introScene = this.el.querySelector('.hero-map__scene-intro');
        this.expertiseScene = this.el.querySelector('.hero-map__scene-expertise');
        this.content = this.el.querySelector('.hero-map__content');
        this.map = this.el.querySelector('.hero-map__image');
        this.expertiseContent = this.el.querySelector('.hero-map__expertise');
        this.pinDistance = 0;
        this.init();
    }

    init() {
        this.initScrollAnimation();
    }

    getMapTransform() {
        const sectionHeight = this.getSectionHeight();
        const mapRect = this.map.getBoundingClientRect();

        const viewportCenterX = window.innerWidth / 2;
        const viewportCenterY = sectionHeight / 2;

        const mapCenterX = mapRect.left + mapRect.width / 2;
        const mapCenterY = mapRect.top + mapRect.height / 2;

        const scaleX = window.innerWidth / mapRect.width;
        const scaleY = sectionHeight / mapRect.height;
        const scale = Math.max(scaleX, scaleY);

        return {
            x: viewportCenterX - mapCenterX,
            y: viewportCenterY - mapCenterY,
            scale,
        };
    }

    initScrollAnimation() {
        if (!this.inner || !this.expertiseScene || !this.map) return;

        let mapTransform = null;

        const updateMapTransform = () => {
            gsap.set(this.map, {
                clearProps: 'transform',
            });

            mapTransform = this.getMapTransform();
        };

        updateMapTransform();

        const sectionHeight = this.el.getBoundingClientRect().height;
        this.pinDistance = sectionHeight * 4;

        gsap.set(this.expertiseScene, {
            yPercent: 100,
        });

        if (this.expertiseContent) {
            gsap.set(this.expertiseContent, {
                y: 80,
            });
        }

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.el,
                start: 'top top',
                end: `+=${this.pinDistance}`,
                scrub: true,
                pin: true,
                pinSpacing: true,
                anticipatePin: 1,
                invalidateOnRefresh: false,
                refreshPriority: -10,
            }
        });

        tl.to(this.content, {
            y: -sectionHeight - 80,
            ease: 'none',
            duration: 1.2,
        }, 0);

        tl.to(this.map, {
            x: () => mapTransform.x,
            y: () => mapTransform.y,
            scale: () => mapTransform.scale,
            opacity: 0.3,
            ease: 'none',
            duration: 2,
        }, 0);

        tl.to(this.expertiseScene, {
            yPercent: 0,
            ease: 'none',
            duration: 1.2,
        }, 1.4);

        if (this.expertiseContent) {
            tl.to(this.expertiseContent, {
                y: 0,
                ease: 'none',
                duration: 1.2,
            }, 1.4);
        }
    }

    getSectionHeight() {
        return this.el.offsetHeight;
    }
}